import api from '@/api'
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage'
import { Decrypt } from '@/utils/crypto'
const state = {
  isH5: false, // 是否是手机端
  isPayCallback: false,

  openedCityList: [], // 开国国家列表
  token: '',
  uid: '',
  locale: '',
  country: 'MX',

  // 登录
  isLogin: false,
  // 是否展示深度链接banner
  isShowDeepLinkBanner: false,

  sidebar: {
    banner: null,
    selfInfo: {},
    sideList: [
      {
        items: [],
      },
      {
        items: [],
      },
    ],
  },
  // 侧边栏icon映射，header&sidebar共用
  sideMap: {
    orders: {
      icon: 'icon-outlined_order',
    },
    payment: {
      icon: 'icon-outlined_payment',
    },
    messages: {
      icon: 'icon-outlined_message',
    },
    help: {
      icon: 'icon-outlined_help',
    },
    settings: {
      icon: 'icon-outlined_setting',
    },
    promotions: {
      icon: 'icon-outlined_special',
    },
    favorite: {
      icon: 'icon-outlined_collection',
    },
    invite: {
      icon: 'icon-outline_invitefriends',
    },
  },
  // 配送的时候用户姓名和电话号码
  userInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    callingCode: '',
  },
  clientHeight: '', // 页面可视区域高度
}

const mutations = {
  setClientHeightState(state, data) {
    state.clientHeight = data
  },
  setIsH5State(state, data) {
    state.isH5 = data
  },
  serIsPayCallback(state, data) {
    state.isPayCallback = data
  },
  setLocale(state, data) {
    state.locale = data
  },
  setCountry(state, data) {
    state.country = data
  },
  setSidebar(state, data) {
    state.sidebar = data
    const phone = Decrypt(state.sidebar?.selfInfo?.phone)
    state.sidebar.selfInfo.phone = phone
  },
  setIsLogin(state, data) {
    state.isLogin = data
  },
  updateOpenedCityList(state, data) {
    state.openedCityList = data
  },
  async getUserInfoMutations(state) {
    // 如果本地没有存取的话，默认拿取用户的手机号码
    let firstNameInfo = null
    let lastNameInfo = null
    let phoneInfo = null
    let callingCodeInfo = null
    if (!state?.sidebar?.selfInfo?.phone) {
      const res = await api.sidebar()
      firstNameInfo = res?.selfInfo?.firstName
      lastNameInfo = res?.selfInfo?.lastName
      phoneInfo = Decrypt(res?.selfInfo?.phone)
      callingCodeInfo = res?.selfInfo?.callingCode
    } else {
      firstNameInfo = state?.sidebar?.selfInfo?.firstName
      lastNameInfo = state?.sidebar?.selfInfo?.lastName
      phoneInfo = state?.sidebar?.selfInfo?.phone
      callingCodeInfo = state?.sidebar?.selfInfo?.callingCode
    }
    const {
      firstName = firstNameInfo,
      lastName = lastNameInfo,
      phone = phoneInfo,
      callingCode = callingCodeInfo,
    } = getLocalStorage('userInfo') || {}
    state.userInfo.firstName = firstName
    state.userInfo.lastName = lastName
    state.userInfo.phone = phone
    state.userInfo.callingCode = callingCode
  },
  setUserInfoMutations(state, param) {
    const { firstName = '', lastName = '', phone = '', callingCode = '' } = param
    state.userInfo.firstName = firstName
    state.userInfo.lastName = lastName
    state.userInfo.phone = phone
    state.userInfo.callingCode = callingCode
    setLocalStorage('userInfo', param)
  },
  setIsShowDeepLinkBanner(state, data) {
    state.isShowDeepLinkBanner = data
  },
}
const actions = {
  setClientHeight({ commit }, param) {
    commit('setClientHeightState', param)
  },
  setIsH5({ commit }, param) {
    commit('setIsH5State', param)
  },
  async getSidebar({ commit }, param) {
    let res = {}
    try {
      res = await api.sidebar(param)
      commit('setSidebar', res)
    } catch {
      return false
    }
    return res
  },
  getUserInfo({ commit }) {
    commit('getUserInfoMutations')
  },
  setUserInfo({ commit }, param) {
    commit('setUserInfoMutations', param)
  },
  /**
   * @description: 获取token
   * @param {type}
   * @return
   */
  async getToken({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getToken(params)
      setLocalStorage('ticket', res?.token)
      setLocalStorage('uid', res?.uid)
      state.token = res?.token
      state.uid = res?.uid
    } catch (e) {
      return false
    }
    return res
  },
  /**
   * @description: 获取已开城城市列表
   * @param {type}
   * @return
   */
  async getCityList({ commit }, params) {
    let res = {}
    try {
      res = await api.getCityList({})
      commit('updateOpenedCityList', res?.cities)
    } catch (e) {
      return false
    }
    return res
  },
  /**
   * @description: capi解析country
   * @param {type}
   * @return
   */
  async getCountry({ commit }, params) {
    let res = {}
    try {
      res = await api.getCountry({})
    } catch (e) {
      return false
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
